module.exports = __webpack_public_path__ + "img/vcy_pic_404.20276cec.png";